import ReactPlayer from "react-player/youtube";
import { Link } from "react-router-dom";
import thumbail from "../../images/logo/logo_aqua.svg";
import { Button } from "../ui/button";
const ServiceHomeSection = () => {
  return (
    <>
      <div className="container mx-auto mb-20 mt-44 md:px-40 sm:px-40 md:mb-10">
        <div className="flex flex-col p-4 xl:flex-row space-x-7">
          <div className="">
            <div className="overflow-hidden rounded-lg w-[450px] h-[300px]">
              <ReactPlayer
                playing={false}
                url="https://www.youtube.com/watch?v=bTPLZolw7rw"
                width="100%"
                height="100%"
              />
            </div>
          </div>
          <div className="flex flex-col   items-start gap-[23px]  mt-10 md:mt-0">
            <p className="relative w-full xl:w-[384px] text-align  mt-[-0.70px]   font-semibold text-[#333333] text-[30px] tracking-[0] leading-[40px]">
              Hydreaulys: Gestion durable de l’eau et des milieux aquatiques à
              l’ouest parisien
            </p>
            <div className="flex  w-full text-justify items-start gap-[91px] relative mb-[-0.14px]">
              <p className="">
                Hydreaulys est un établissement territorial en charge de la
                collecte, du transport et de l’assainissement des eaux usées et
                pluviales de l’ouest parisien. Il gère également l’aménagement,
                la restauration, l’entretien et la mise en valeur du ru de
                Gally. Son territoire s’étend sur 31 communes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceHomeSection;
